
import Vue from "vue";
import { FunnelsServices } from "@/services";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      domains: []
    };
  },
  methods: {
    async fetchAllDomains() {
      try {
        if (!this.locationId) return;
        const { data } = await FunnelsServices.listDomains({ locationId: this.locationId });
        console.log(data);
        this.domains = data.domains;
      } catch (error) {
        console.error(error);
      }
    }
  }
});
